import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
} from "react-bootstrap";
import { FiPlus, FiImage } from "react-icons/fi";
import GalleryModal from "./GalleryModal";
import {  FiTrash2 } from "react-icons/fi";

import { useRef,  } from "react";
import AddNewCompany from "./AddNewCompany";

export default function AddLeadModal({ show, handleClose}) {
  const [phones, setPhones] = useState([""]);
  const [emails, setEmails] = useState([""]);
  const [showGallery, setShowGallery] = useState(false);
const [tags, setTags] = useState(["Collab"]);
const [inputValue, setInputValue] = useState("");
  const addPhone = () => setPhones([...phones, ""]);
  const addEmail = () => setEmails([...emails, ""]);
  const [companyShow, setcompanyShow] = useState(false);
// description

const editorRef = useRef(null);
const [fontSize, setFontSize] = useState("14");

const formatText = (command) => {
  document.execCommand(command, false, null);
};

const changeFontSize = (size) => {
  setFontSize(size);
  document.execCommand("fontSize", false, "7");

  const fontElements = editorRef.current.getElementsByTagName("font");
  for (let i = 0; i < fontElements.length; i++) {
    if (fontElements[i].size === "7") {
      fontElements[i].removeAttribute("size");
      fontElements[i].style.fontSize = size + "px";
    }
  }
};
  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Lead</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* Lead Name */}
            <Form.Group className="mb-3">
              <Form.Label>Lead Name *</Form.Label>
              <Form.Control />
            </Form.Group>

            {/* Person / Organization */}
            <div className="mb-3 d-flex gap-3">
              <Form.Check label="Person" name="type" type="radio" />
              <Form.Check label="Organization" name="type" type="radio" />
            </div>

            {/* Company */}
            <Row className="mb-3">
              <Col>
                <Form.Label>Company *</Form.Label>
                <div className="d-flex justify-content-between">
                  <span></span>
             <span
  className="add-new"
  onClick={() => setcompanyShow(true)}
>
  + Add New
</span>
                </div>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Col>
            </Row>

            {/* Value + Currency */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Value *</Form.Label>
                <Form.Control />
              </Col>
              <Col md={6}>
                <Form.Label>Currency *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Col>
            </Row>

            {/* Phone */}
            <Form.Label>Phone Number *</Form.Label>
{phones.map((p, i) => (
  <div className="phone-group mb-2" key={i}>
    
    <Form.Control className="phone-input" />

    <Form.Select className="phone-select">
      <option>Work</option>
    </Form.Select>

    {i === 0 ? (
      <Button
        variant="light"
        className="icon-btn add"
        onClick={addPhone}
      >
        <FiPlus />
      </Button>
    ) : (
      <Button
        variant="light"
        className="icon-btn delete"
        onClick={() =>
          setPhones(phones.filter((_, index) => index !== i))
        }
      >
        <FiTrash2 />
      </Button>
    )}
  </div>
))}

            {/* Email */}
            <Form.Label>Email *</Form.Label>
         {emails.map((e, i) => (
  <div className="phone-group mb-2" key={i}>
    
    {/* EMAIL INPUT */}
    <Form.Control
      type="email"
      className="phone-input"
      placeholder="Enter email"
    />

    {/* TYPE SELECT */}
    <Form.Select className="phone-select">
      <option>Work</option>
      <option>Personal</option>
    </Form.Select>

    {/* ICON */}
    {i === 0 ? (
      <button
        type="button"
        className="icon-btn add"
        onClick={addEmail}
      >
        <FiPlus />
      </button>
    ) : (
      <button
        type="button"
        className="icon-btn delete"
        onClick={() =>
          setEmails(emails.filter((_, index) => index !== i))
        }
      >
        <FiTrash2 />
      </button>
    )}
    
  </div>
))}

            {/* Source + Industry */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Source *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Col>
              <Col md={6}>
                <Form.Label>Industry *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Col>
            </Row>

            {/* Owner + Tags */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Owner *</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Col>
<Col md={6}>
  <Form.Label>Tags *</Form.Label>

  <div className="tags-wrapper">
    
    {/* TAGS */}
    {tags.map((tag, index) => (
      <div className="tag-item" key={index}>
        {tag}
        <span
          className="tag-close"
          onClick={() =>
            setTags(tags.filter((_, i) => i !== index))
          }
        >
          ×
        </span>
      </div>
    ))}

    {/* INPUT ALWAYS LAST */}
    <input
      type="text"
      className="tag-input"
      value={inputValue}
      placeholder="Add new"
      onChange={(e) => setInputValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter" && inputValue.trim()) {
          e.preventDefault();
          setTags([...tags, inputValue.trim()]);
          setInputValue("");
        }
      }}
    />
  </div>
</Col>   </Row>

            {/* DESCRIPTION */}
           <Form.Group className="mb-3">
  <Form.Label>Description *</Form.Label>

  {/* TOOLBAR */}
  <div className="editor-toolbar">
    <select
      value={fontSize}
      onChange={(e) => changeFontSize(e.target.value)}
    >
      {[8, 9, 10, 11, 12, 14, 18, 24, 36].map((size) => (
        <option key={size}>{size}</option>
      ))}
    </select>

    <button type="button" onClick={() => formatText("bold")}>
      <b>B</b>
    </button>

    <button type="button" onClick={() => formatText("italic")}>
      <i>I</i>
    </button>

    <button type="button" onClick={() => formatText("underline")}>
      <u>U</u>
    </button>

    <button type="button" onClick={() => formatText("strikeThrough")}>
      <s>S</s>
    </button>

    <button
      type="button"
      onClick={() => setShowGallery(true)}
    >
      <FiImage />
    </button>
  </div>

  {/* EDITOR AREA */}
  <div
    ref={editorRef}
    className="editor-box"
    contentEditable
  ></div>
</Form.Group>

            {/* Visibility + Status */}
            <Row>
              <Col md={6}>
                <Form.Label>Visibility</Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check label="Public" type="radio" />
                  <Form.Check label="Private" type="radio" />
                  <Form.Check label="Select People" type="radio" />
                </div>
              </Col>
              <Col md={6}>
                <Form.Label>Status</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-orange">Add Lead</Button>
        </Modal.Footer>
        <AddNewCompany
  show={companyShow}
  handleClose={() => setcompanyShow(false)}
/>
        <style>
          {
            `
            /* ORANGE THEME */
.btn-orange {
  background: #ff6a00;
  color: #fff;
  border: none;
}
.btn-orange:hover {
  background: #e65c00;
}

/* ADD NEW */
.add-new {
  color: #ff6a00;
  cursor: pointer;
  font-size: 13px;
}

/* DROPDOWN ACTIVE */
.form-select:focus {
  border-color: #ff6a00;
  box-shadow: 0 0 0 0.2rem rgba(255,106,0,0.2);
}

/* EDITOR */
.editor-toolbar {
  display: flex;
  gap: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  border-bottom: none;
}
.editor-toolbar button {
  border: none;
  background: #f5f5f5;
  padding: 5px 8px;
}
.editor-box {
  width: 100%;
  height: 120px;
  border: 1px solid #ddd;
  resize: none;
}

/* GALLERY */
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.gallery-grid img {
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
}

.phone-group .form-control {
  height: 44px;
}

.phone-select {
  max-width: 130px;
  height: 44px;
}

.phone-group {
  display: flex;
  align-items: center;
  gap: 12px; /* 🔥 THIS creates space like your image */
}

.phone-input {
  flex: 1;
  height: 44px;
  border-radius: 6px;
}

.phone-select {
  width: 140px;
  height: 44px;
  border-radius: 6px;
}

/* ICON BUTTON */
.icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* COLORS */
.icon-btn.add {
  color: #ff6a00;
}

.icon-btn.delete {
  color: #ff3b30;
}


// emails


.phone-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.phone-input {
  flex: 1;
  height: 44px;
}

.phone-select {
  width: 140px;
  height: 44px;
}

.icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-btn.add {
  color: #ff6a00;
}

.icon-btn.delete {
  color: #ff3b30;
}


// descrption

/* TOOLBAR */
.editor-toolbar {
  display: flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #ddd;
  border-bottom: none;
  padding: 6px;
  background: #f9f9f9;
  border-radius: 6px 6px 0 0;
}

/* DROPDOWN */
.editor-toolbar select {
  border: 1px solid #ddd;
  height: 32px;
  padding: 0 5px;
}

/* BUTTONS */
.editor-toolbar button {
  border: 1px solid #ddd;
  background: #fff;
  padding: 4px 8px;
  cursor: pointer;
}

.editor-toolbar button:hover {
  background: #f1f1f1;
}

/* EDITOR BOX */
.editor-box {
  min-height: 140px;
  border: 1px solid #ddd;
  border-radius: 0 0 6px 6px;
  padding: 10px;
  outline: none;
  background: #fff;
}

// tags
/* CONTAINER */
.tags-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;      /* ❌ NO WRAP */
  overflow-x: auto;       /* ✅ SCROLL */
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 8px;
  min-height: 42px;
  gap: 6px;
}

/* TAG */
.tag-item {
  display: inline-flex;
  align-items: center;
  background: #f1f3f5;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 13px;
  white-space: nowrap;
}

/* CLOSE */
.tag-close {
  margin-left: 6px;
  cursor: pointer;
}

/* INPUT */
.tag-input {
  border: none;
  outline: none;
  flex: 1;
  min-width: 120px;
  background: transparent;
}

/* IMPORTANT: prevent breaking */
.tags-wrapper * {
  flex-shrink: 0;
}


/* MOBILE */
@media (max-width: 768px) {
  .editor-toolbar {
    flex-wrap: wrap;
  }
}
/* RESPONSIVE */
@media (max-width: 768px) {
  .modal-dialog {
    max-width: 95%;
  }
}`
          }
        </style>
      </Modal>

      {/* Gallery Modal */}
      <GalleryModal
        show={showGallery}
        onHide={() => setShowGallery(false)}
      />
    </>
  );
}